import { render, staticRenderFns } from "./StudentSubjects.vue?vue&type=template&id=b3411882"
import script from "./StudentSubjects.vue?vue&type=script&lang=js"
export * from "./StudentSubjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports